export default __webpack_public_path__ + "static/media/stock-3.aba2d5b9.jpg";